import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { MainBunnerWithLoader } from './loaders';
import { getWebBanners } from '../../../../actions/mainPage/thunks';

export const MainBanner = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getWebBanners());
    }, []);

    return <MainBunnerWithLoader />;
};
